import { cn } from '@/lib/utils';
import { SEARCH_TYPE_LABELS } from '@/lib/smart-search';
import { type SearchType } from '@/types/search-criteria';

interface SearchTypeTabsProps {
    value: SearchType;
    onChange: (type: SearchType) => void;
    className?: string;
    /** id prefix of the tab panels controlled by the tabs. */
    idPrefix?: string;
}

const TYPES: SearchType[] = ['embarcacoes', 'empresas'];

/**
 * "Embarcações | Empresas" tabs of the search card, the top bar and the mobile search (CN-200). Boats use the site
 * blue, companies the teal of the prototype (#0f766e).
 */
export function SearchTypeTabs({ value, onChange, className, idPrefix = 'search-type' }: SearchTypeTabsProps) {
    return (
        <div role="tablist" aria-label="Tipo de busca" className={cn('flex gap-6 border-b border-gray-200', className)}>
            {TYPES.map((type) => {
                const selected = type === value;

                return (
                    <button
                        key={type}
                        id={`${idPrefix}-tab-${type}`}
                        type="button"
                        role="tab"
                        aria-selected={selected}
                        aria-controls={`${idPrefix}-panel-${type}`}
                        tabIndex={selected ? 0 : -1}
                        onClick={() => onChange(type)}
                        onKeyDown={(event) => {
                            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
                                event.preventDefault();
                                onChange(type === 'empresas' ? 'embarcacoes' : 'empresas');
                            }
                        }}
                        className={cn(
                            '-mb-px border-b-2 px-1 pb-3 text-sm font-medium transition-colors sm:text-base',
                            selected
                                ? type === 'empresas'
                                    ? 'border-[#0f766e] text-[#0f766e]'
                                    : 'border-blue-800 text-blue-800'
                                : 'border-transparent text-gray-600 hover:text-gray-900',
                        )}
                    >
                        {SEARCH_TYPE_LABELS[type]}
                    </button>
                );
            })}
        </div>
    );
}
